module.exports = __webpack_public_path__ + "static/media/city5.e2ca8f7d.jpg";